var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2739 3.25715C1.75123 2.70876 2.59667 2.68942 3.09858 3.2154L4.89434 5.09729C4.90157 5.10488 4.91367 5.10489 4.92092 5.09733L9.45141 0.375003C9.90656 -0.0994267 10.6666 -0.0947058 11.1159 0.385342C11.5377 0.83616 11.5268 1.5401 11.0912 1.97764L4.98992 8.10575C4.94386 8.15202 4.86957 8.15389 4.82123 8.11001L1.37536 4.98209C0.877855 4.53048 0.83277 3.76397 1.2739 3.25715Z",
    fill: "#F9F9FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledCheck);
export default __webpack_public_path__ + "static/media/DisabledCheck.fa261587eec6d7a9a4c20025051190ad.svg";
export { ForwardRef as ReactComponent };